// export const crmUrl = 'https://faircar.in/apiv1';
export const crmUrl = 'https://wisedrive.co.in/apiv1';

export const basicAuth = {
  auth: {
    username: 'prasad',
    password: 'prasad@123',
  },
};
export const basicAuthMy = {
  auth: {
    username: 'malaysiawd@gmail.com',
    password: 'prasad@123',
  },
};

export const basicAuthTh = {
  auth: {
    username: 'kalyan.th@wisedrive.com',
    password: 'prasad@123',
  },
};
